module.exports = __webpack_public_path__ + "static/media/bo.1c74a1b0.m4a";